import styled from "styled-components";

const GlowingText = styled.strong`
  color: #6ef0e8;
  text-transform: uppercase;
  position: relative;
  text-shadow:
    0 0 4px #6ef0e8,
    0 0 10px #6ef0e8,
    0 0 20px #6ef0e8;
`;

export default GlowingText;
